module.exports = __webpack_public_path__ + "static/media/dus_ven.6ddbb26f.png";